import { gql } from '@apollo/client';

export type DeleteFavouriteSupplierVariables = {
  supplierId: string;
};

export type DeleteFavouriteSupplierResponse = {
  deleteFavouriteSuppliers: boolean | null;
};

export const DELETE_FAVOURITE_SUPPLIER = gql`
  mutation deleteFavouriteSuppliers($supplierId: String!) {
    deleteFavouriteSuppliers(supplierId: $supplierId)
  }
`;
